import React, { Fragment } from 'react';
import 'highlight.js/styles/github.css';
import './App.css';
import { useViewportDimenions } from './useViewportDimensions';
import { useScrollTop } from './useScrollTop';
import { useSlideViewModels } from "./useSlideViewModels";
import { SequenceSlideView } from "./NewImageSequenceSlideView";
import { StandAloneSlideView } from "./StandAloneSlideView";
import { getCurrentSlideIdx } from "./render-helpers";

const App: React.FC = () => {
  const scrollTop = useScrollTop();
  const viewportDimensions = useViewportDimenions();
  const slides = useSlideViewModels();

  if (slides.length === 0) {
      return <div style={{ textAlign: "center" }}><img src="images/loading.gif"/></div>
  }

  const content: JSX.Element[] = [];
  const currentSlideIdx = getCurrentSlideIdx(scrollTop, slides);

  let heightOffset = 0;
  slides.forEach((slide, idx) => {
    const internalScrollTop = scrollTop - heightOffset;
    if (slide.type === "stand-alone") {
      content.push(
        <StandAloneSlideView
          slide={slide}
          key={idx}
          idx={idx}
          currentIdx={currentSlideIdx}
          scrollTop={internalScrollTop}
          viewportDimensions={viewportDimensions}
        />);
    } else if (slide.type === "sequence") {
      content.push(
        <SequenceSlideView
          slide={slide}
          key={idx}
          idx={idx}
          currentIdx={currentSlideIdx}
          scrollTop={internalScrollTop}
          viewportDimensions={viewportDimensions}
        />);
    } else {
      throw new Error("Unknown slide type: " + slide["type"]);
    }
    heightOffset += slide.slideHeight;
  });

  return (
    <Fragment>
      {content}
    </Fragment>
  );
}

export default App;
